<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:15:33
 * @FilePath: \Home\Transfor-website\src\components\pc\Header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div>
    <!-- <div class="homes globheader"> -->
    <div :class="currentRouteClass">
      <!-- <div class="home-W"> -->
      <div :class="currentRouteClass1">
        <div class="logo" @click="Home">
          <div class="logo_all">
            <img src="../../assets/pc/Home/HomeLogo.svg" alt="" />
            <div class="Home_logo">Transformers</div>
          </div>
        </div>
        <div class="menu">
          <ul
            :class="{
              active4: borId === 1,
              active5: borId === 2,
              active6: borId === 3,
              active7: borId === 4,
              active8: borId === 5,
            }"
          >
            <li
              v-for="(item, index) in list"
              :class="{
                active3: clientId === 2,
                actives: index === id,
              }"
              ref="element"
            >
              <p
                @mouseenter="YiRu(index, $event)"
                @mouseleave="yichu(index, $event)"
                @click="Ecosphere(index)"
              >
                {{ item.name
                }}<i class="iconfont" v-show="index != 3">&#xe87e;</i>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div
      class="XiaL"
      :class="{
        active: id === 0,
        active1: clientId === 0,
      }"
      @mouseleave="YiCU"
    > -->
    <div :class="getCombinedClass(0)" @mouseleave="YiCU">
      <ul>
        <li>
          <p>Home</p>
          <!-- <router-link
            to="/Index/StartBuilding"
            @click="StartBuilding"
            :class="{ StartColor: Scolor === '1-1' }"
          > -->
          <router-link
            :to="'/' + goPage + '/StartBuilding'"
            @click="StartBuilding"
            :class="{ StartColor: Scolor === '1-1' }"
          >
            <p id="active2">
              Start building <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <p>
            <!-- <a href="https://www.tfsc.io/doc/structure/network" target="_blank"> -->
            <a :href="`${baseUrl}/doc/structure`" target="_blank">
              Transformers architecture
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
        <li>
          <p>Document</p>

          <p>
            <a :href="`${baseUrl}/doc/developer`" target="_blank">
              Develop documentation
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
          <p>
            <a
             :href="`${baseUrl}/doc/developer/set`"
              target="_blank"
            >
              API documentation <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
        <li>
          <p>Application</p>
          <p>
            <a
              :href="`${baseUrl}/doc/run-node`"
              target="__blank"
            >
              Deploy application <i class="iconfont icon-jiantou_xiangyou"></i
            ></a>
          </p>
        </li>
      </ul>
    </div>
    <div class="XiaL" :class="getCombinedClass(1)" @mouseleave="YiCU">
      <ul>
        <li>
          <p>Transformers</p>
          <router-link
            :to="'/' + goPage + '/Overview'"
            :class="{ StartColor: Scolor === '2-1' }"
          >
            <p id="active2">
              Transformers overview
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <!-- <router-link
            to="/pc/Wallet"
            :class="{ StartColor: Scolor === '2-2' }"
          >
            <p id="active2">
              Transformers wallet <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link> -->
          <a
            href="https://explorer.tfsc.io/"
            target="_blank"
            :class="{ StartColor: Scolor === '2-3' }"
          >
            <p id="active2">
              Transformers testnet Explorer
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </a>
        </li>
        <li>
          <p>Ecological</p>
          <p>
            <a
              :href="`${baseUrl}/doc/ecology/overview`"
              target="_blank"
            >
              Ecosystem economic overview
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
          <p>
            <a :href="`${baseUrl}/doc/ecology/expenditure#stake`" target="_blank">
              Stake TTOS <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
        <li>
          <p>More</p>
          <!-- <p @click="Obtain('#twe')"> -->
          <p>
            <a
              :href="`${baseUrl}/doc/ecology/revenue`"
              target="_blank"
              >Obtain revenue <i class="iconfont icon-jiantou_xiangyou"></i
            ></a>
          </p>
          <p>
            <a
              :href="`${baseUrl}/doc/ecology/inflation`"
              target="_blank"
            >
              Financial instrument
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
      </ul>
    </div>
    <div :class="getCombinedClass(2)" @mouseleave="YiCU">
      <ul>
        <li>
          <p>Transformers</p>

          <p>
            <a :href="`${baseUrl}/doc/intro/`" target="_blank">
              Preliminary understanding of Transformers
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
        <li>
          <p>Technical detail</p>
          <p>
            <a :href="`${baseUrl}/doc/`" target="_blank">
              Technology wiki <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
          <p>
            <a href="https://github.com/tfs-labs" target="_blank">
              Open-source code <i class="iconfont icon-jiantou_xiangyou"></i>
            </a>
          </p>
        </li>
        <!-- <li>
          <p>More</p>
          <p>
            Technology roadmap <i class="iconfont icon-jiantou_xiangyou"></i>
          </p>
        </li> -->
      </ul>
    </div>
    <div :class="getCombinedClass(4)" @mouseleave="YiCU">
      <ul>
        <li>
          <p>Contact us <i class="iconfont icon-jiantou_xiangyou"></i></p>
          <!-- <router-link to="/pc/Email" :class="{ StartColor: Scolor === '4-1' }"> -->
          <!-- <a href="#miao"> -->
          <p @click="goAuchor('#one')">
            Subscribe campaign email
            <i class="iconfont icon-jiantou_xiangyou"></i>
          </p>
          <!-- </a> -->

          <!-- </router-link> -->
        </li>
        <li>
          <p>
            Activity
            <span class="update" @click="update"
              >Update Reward Wallet Address</span
            >
          </p>
          <!-- <router-link
            :to="'/' + goPage + '/Ranking'"
            :class="{ StartColor: Scolor === '4-3' }"
          >
            <p id="active2">
              Community Invitation
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <router-link
            :to="'/' + goPage + '/LotteryRecord'"
            :class="{ StartColor: Scolor === '4-4' }"
          >
            <p id="active2">
              Daily Lottery Announcement
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <router-link
            :to="'/' + goPage + '/Integral'"
            :class="{ StartColor: Scolor === '4-5' }"
          >
            <p id="active2">
              X Points
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link> -->
          <router-link
            :to="'/' + goPage + '/MintNFT'"
            :class="{ StartColor: Scolor === '4-6' }"
          >
            <p id="active2">
              Mainnet Launch Pass (NFT)
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <!-- <router-link to="/pc/Group" :class="{ StartColor: Scolor === '4-2' }">
            <p id="active2">
              Join Transformers group
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
         
          <a href="https://www.tfsc.io/test-tfscbrowser-periodone" target="_blank"
            >
            <p id="active2">
              Beta test data query
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </a> -->
        </li>
        <li>
          <p>Social</p>
          <!-- <a href="https://www.tfsc.io/test-tfscbrowser-periodone" target="_blank"
            > -->
          <router-link :to="'/' + goPage + '/Ambassador'" target="_blank">
            <p id="active2">
              Ambassador Program
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <router-link :to="'/' + goPage + '/Brand'" target="_blank">
            <p id="active2">
              Brand Kit
              <i class="iconfont icon-jiantou_xiangyou"></i>
            </p>
          </router-link>
          <!-- </a> -->
          <a href="https://medium.com/@transformerschain" target="_blank"
            ><p class="Social-Img2 Social-Img"></p
          ></a>
          <a href="https://twitter.com/TFSCChain" target="_blank"
            ><p class="Social-Img3 Social-Img"></p
          ></a>
          <a href="https://t.me/transformerschain" target="_blank"
            ><p class="Social-Img4 Social-Img"></p
          ></a>
          <!-- <a href="https://discord.gg/tfscchain001"
            > -->
          <a href="https://discord.com/invite/W4YsQduNrf" target="_blank">
            <p class="Social-Img5 Social-Img"></p
          ></a>
          <a
            href="https://www.youtube.com/channel/UCxkH0sBwC9cASd3c3qwyvmA"
            target="_blank"
            ><p class="Social-Img6 Social-Img"></p
          ></a>
          <a href="https://github.com/tfs-labs" target="_blank"
            ><p class="Social-Img7 Social-Img"></p
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { base2 } from "@/assets/server/api";
import { goPAGE } from "@/utils/utils";
import Main from "@/components/m/Main.vue";
export default {
  watch: {
    deep: true,
    $route: {
      handler: function (route) {
      //  console.log(route);
        if (route.fullPath === "/Index") {
          this.borId = "";
          this.clientId = 0;
          // this.ImgUrl1 = require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png");
        } else if (route.fullPath === "/Index/StartBuilding") {
          this.Scolor = "1-1";
          this.borId = 1;
          // this.ImgUrl1 = require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png");
          this.clientId = 0;
        } else if (route.fullPath === "/Index/Wallet") {
          this.Scolor = "";
          this.Scolor = "2-2";
          this.borId = 2;
          this.clientId = 2;
          // this.ImgUrl = require("../../assets/pc/Home/组 27@2x.png");
          this.ImgUrl1 = this.ImgUrl2;
          //  console.log("/pc/Wallet", this.clientId);
        } else if (route.fullPath === "/Index/Ecological") {
          this.Scolor = "";
          this.borId = 5;
          // this.ImgUrl1 = require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png");
          this.clientId = 0;
        } else if (route.fullPath === "/Index/Overview") {
          this.Scolor = "";
          this.Scolor = "2-1";
          this.borId = 2;
          // this.ImgUrl1 = require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png");
          this.clientId = 0;
        } else if (route.fullPath === "/Index/Email") {
          this.Scolor = "";
          this.Scolor = "4-1";
          this.borId = 4;
          // this.ImgUrl1 = require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png");
          this.clientId = 0;
        } else if (route.fullPath === "/Index/Ranking") {
          this.Scolor = "";
          this.Scolor = "4-3";
          this.borId = 4;
          this.clientId = 0;
        } else if (route.fullPath === "/Index/LotteryRecord") {
          this.Scolor = "";
          this.Scolor = "4-4";
          this.borId = 4;
          this.clientId = 0;
        } else if (route.fullPath === "/Index/Integral") {
          this.Scolor = "";
          this.Scolor = "4-5";
          this.borId = 4;
          this.clientId = 0;
        } else if (route.fullPath === "/Index/MintNFT") {
          this.Scolor = "";
          this.Scolor = "4-6";
          this.borId = 4;
          this.clientId = 0;
        }

        // else if (route.fullPath === "/pc/Group") {
        //   this.Scolor = "";
        //   this.Scolor = "4-2";
        //   this.borId = 4;

        //   this.clientId = 0;
        // }
      },
      immediate: true,
    },
    screenWidth(newVal) {
      // console.log("newVal", newVal);
      // console.log('old', old);
      // this.boxWscreenWidthidth = document.body.clientWidth;
      // console.log('new', this.boxWidth);
    },
  },
  data() {
    return {
      baseUrl: base2,
      language: "EN",
      language2: "ZH",
      Index: "",
      headerclass: true,
      ElSubmenuborder: "",
      ImgUrl: require("../../assets/pc/Home/Home5.png"),
      ImgUrl1: require("../../assets/pc/Home/arrow ／ chevron_down 2@2x.png"),
      ImgUrl2: require("../../assets/pc/Wallet/Wallet1.png"),
      list: [
        {
          name: "Developer",
        },
        {
          name: "Learning",
        },
        {
          name: "Technology",
        },
        {
          name: "Ecosphere",
        },
        {
          name: "Community",
        },
      ],
      id: "", //设置下拉框是否显示
      clientId: "", //设置wallet页面导航栏颜射
      borId: "",
      index: 0,
      Scolor: "",
      W: document.body.clientWidth + "px",
      screenWidth: document.body.clientWidth + "px",
      x: "",
      y: "",
    };
  },
  created() {
    this.clientId = 0;
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
      // console.log("浏览器窗口", that.screenWidth);
    };
    window.addEventListener("load", function () {
      // 获取当前的哈希部分
      var hash = window.location.hash;

      // 如果哈希部分以 #/pc/ 开头，进行重定向
      if (hash && hash.startsWith("#/pc/")) {
        var newPath = hash.replace("#/pc/", "/Index/");
        window.location.href = newPath;
      }
    });
  },
  computed: {
    currentRouteClass() {
      return this.$route.path === "/Index/MintNFT" ? "minthomes" : "homes";
    },
    currentRouteClass1() {
      return this.$route.path === "/Index/MintNFT" ? "minthome-W " : "home-W";
    },
    baseClass() {
      return this.$route.path === "/Index/MintNFT" ? "mintXiaL" : "XiaL";
    },
    goPage() {
      return goPAGE();
    },
  },
  methods: {
    getCombinedClass(index) {
      return {
        [this.baseClass]: true,
        active: this.id === index,
        active1: this.clientId === 0,
      };
    },
    update() {
      this.$router.push("/Index/Address");
    },
    YiRu(index, e) {
      if (index != 3) {
        this.id = index;
      } else if (index === 3) {
        this.id = index;
      } else {
        this.id = "";
      }
    },
    YiCU() {
      this.id = "";
    },
    yichu(index, e) {
      this.x = e.offsetX; //获取鼠标的X坐标（鼠标与屏幕左侧的距离，单位为px）
      this.y = e.offsetY; //获取鼠标的Y坐标（鼠标与屏幕顶部的距离，单位为px）
      if (this.x < 0 || this.x >= 115 || this.y <= 0) {
        this.id = "";
      }
    },
    Ecosphere(index) {
      if (index === 3) {
        this.id = index;
        this.$router.push("/Index/Ecological");
      }
    },
    StartBuilding() {
      this.Scolor = "1-1";
    },
    Home() {
      this.Scolor = "";
      this.$router.push("/Index");
    },
    // 搜索锚点
    goAuchor(id) {
      document.querySelector(id).scrollIntoView(true);
      var auchor = this.$el.querySelector(id);
      // console.log(auchor.getBoundingClientRect().top);
      // document.body.scrollTop = auchor.offsetTop;
    },
    // 不同页面跳转技术路线图锚点
    // Obtain(id) {
    //   this.$router.push("/pc/Index");
    //   document.querySelector(id).scrollIntoView(true);
    //   var auchor = this.$el.querySelector(id);
    // },
    Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>
<style lang="less" scoped>
@import url("https://at.alicdn.com/t/font_3404326_ql4lpukg2ri.css");
.minthomes {
  width: 100%;
  background: #150226;
  z-index: 10;
}
.homes {
  width: 100%;
  background: #f4f4f4;
  z-index: 10;
}
.minthome-W {
  background: #150226;
  color: #fff;
  .logo {
    flex: 0 0 40%;
    padding: 16px 0;

    .logo_all {
      width: 190px;
      display: flex;
      cursor: pointer;
      .Home_logo {
        flex: 0 0 75%;
        color: #fff;
      }
    }
  }
  .menu {
    p {
      color: #fff;
    }
  }
}
.home-W {
  background: #f4f4f4;
}
.home-W,
.minthome-W {
  width: 1320px;
  height: 64px;
  margin: 0 auto;
  display: flex;

  .logo {
    flex: 0 0 40%;
    padding: 16px 0;

    .logo_all {
      width: 190px;
      display: flex;
      cursor: pointer;
      .Home_logo {
        flex: 0 0 75%;
      }
      img {
        flex: 0 0 25%;
        width: 34px;
        height: 30px;
        margin-right: 10px;
      }
      font-size: 20px;
      font-family: "Microsoft YaHei";
      // font-family: HarmonyOS Sans SC-Black;
      font-weight: 900;
      color: #141414;
      line-height: 28px;
    }
  }
  .menu {
    flex: 0 0 60%;
    ul {
      display: flex;
      li {
        flex: 1;
        // line-height: 60px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        //font-family: Poppins-Medium, Poppins;
        color: rgba(0, 0, 0, 0.800000011920929);
        cursor: default;
        padding: 20px 0 0 0;
        p {
          width: 118px;
          height: 24px;
          line-height: 24px;
          font-family: "Microsoft YaHei";
          // font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
          //   "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
          //   sans-serif;
          font-weight: 650;
          i {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
.XiaL {
  background: #f4f4f4;
  ul {
    background: #f4f4f4;
    li {
      a {
        #active2 {
          color: rgba(20, 20, 20, 0.800000011920929);
        }
      }
      p {
        a {
          color: rgba(20, 20, 20, 0.800000011920929);
        }
      }
      p:nth-child(1) {
        border-bottom: 1px solid rgba(20, 20, 20, 0.15000000596046448);
      }
      p:nth-child(2) {
        color: rgba(20, 20, 20, 0.800000011920929);
      }

      p:nth-child(3) {
        color: rgba(20, 20, 20, 0.800000011920929);
      }
    }
  }
}
.mintXiaL {
  background: #140124;
  //  background: #f4f4f4;
  ul {
    background: #140124;
    li {
      a {
        #active2 {
          color: #fff;
        }
      }
      p {
        a {
          color: #fff;
        }
      }
      p:nth-child(1) {
        color: rgba(255, 255, 255, 0.6);
        // border-bottom: 1px solid red;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
      p:nth-child(2) {
        color: #fff;
      }

      p:nth-child(3) {
        color: #fff;
      }
    }
    //  background: #f4f4f4;
  }
}
.XiaL,
.mintXiaL {
  position: absolute;
  top: 64px;
  left: 0;
  width: 100%;
  z-index: 10;
  overflow: hidden;
  height: 0;
  // background: #f4f4f4;
  ul {
    width: 1320px;
    margin: 0 auto;
    display: flex;
    //  background: #f4f4f4;
    height: 265px;
    // border: 1px solid red;
    li {
      flex: 1;
      padding: 0 20px;
      margin: 0 45px 0 0;
      a {
        #active2 {
          padding: 12px 0 !important;
          border-bottom: none !important;
          // color: rgba(20, 20, 20, 0.800000011920929);
          //color: yellow;
          font-family: "Microsoft YaHei";
          // font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
          //   "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
          //   sans-serif;
          font-weight: 650;
          .icon-jiantou_xiangyou {
            display: none;
          }
        }
        #active2:hover {
          color: #cf61dc !important;
          .icon-jiantou_xiangyou {
            display: block;
            display: inline-block;
          }
        }
        border: none;
      }
      p {
        a {
          // color: rgba(20, 20, 20, 0.800000011920929);
          // color: red;
        }
      }
      p:nth-child(1) {
        font-size: 16px;
        // font-family: Poppins-Medium, Poppins;
        // font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
        //   "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        //   sans-serif;
        font-family: "Microsoft YaHei";
        font-weight: 500;

        // color: rgba(20, 20, 20, 0.6000000238418579);
        //   border-bottom: 1px solid rgba(20, 20, 20, 0.15000000596046448);
        //  border-bottom: 1px solid red;
        padding: 34px 0 12px 0;
        .update {
          display: inline-block;
          width: 243px;
          height: 29px;
          line-height: 29px;
          text-align: center;
          background: #cd60d9;
          border-radius: 4px 4px 4px 4px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 14px;
          color: #f4f4f4;
          cursor: pointer;
          margin-left: 42px;
        }
        .icon-jiantou_xiangyou {
          display: none;
        }
      }
      p:nth-child(2) {
        cursor: pointer;
        font-size: 16px;
        // font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
        //   "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        //   sans-serif;
        // font-family: Poppins-Medium, Poppins;
        font-family: "Microsoft YaHei";
        font-weight: 650;
        // color: #abcdef;
        //  color: rgba(20, 20, 20, 0.800000011920929);
        padding: 12px 0;
        .icon-jiantou_xiangyou {
          display: none;
        }
      }
      p:nth-child(2):hover {
        color: #cf61dc !important;
        .icon-jiantou_xiangyou {
          display: block;
          display: inline-block;
        }
      }
      p:nth-child(3):hover {
        color: #cf61dc !important;
        .icon-jiantou_xiangyou {
          display: block;
          display: inline-block;
        }
      }
      p:nth-child(3) {
        cursor: pointer;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        // font-family: Poppins-Medium, Poppins, "Segoe UI", "Roboto", "Oxygen",
        //   "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        //   sans-serif;
        // font-family: Poppins-Medium, Poppins;
        font-weight: 650;
        // color: rgba(20, 20, 20, 0.800000011920929);
        //  color: blue;
        padding: 12px 0;
        .icon-jiantou_xiangyou {
          display: none;
        }
      }
    }
  }
}
.Home {
  width: 410px;
  padding-bottom: 10px;
  display: inline-block;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  // font-family: Poppins-Medium, Poppins;
  font-weight: 530;
  color: rgba(255, 255, 255, 0.6000000238418579);
  border-bottom: 1px solid #4d4d4d;
  padding-left: 10px;
}
.active {
  transition: all 0.5s;
  height: 265px;
  box-shadow: 0px 113px 100px 1px rgba(0, 0, 0, 0.4000000059604645);
}
.actives:hover {
  p {
    color: #cd60d9 !important;
  }
  .iconfont {
    display: inline-block;
    transition: all 0.5s;
    transform: rotate(180deg) !important ;
  }
}
.StartColor {
  p {
    color: #cd60d9 !important;
    .icon-jiantou_xiangyou {
      display: block !important;
      display: inline-block !important;
    }
  }
}
.active3 {
  color: #000 !important;
}
.active4 {
  li:nth-child(1) {
    // color: #cd60d9 !important;
    .iconfont {
      display: inline-block;
      // transition: all 0.5s;
      // transform: rotate(180deg);
    }
  }
}
.active5 {
  li:nth-child(2) {
    // color: #cd60d9 !important;
    .iconfont {
      display: inline-block;
      // transition: all 0.5s;
      // transform: rotate(180deg);
    }
  }
}
.active6 {
  li:nth-child(3) {
    // color: #cd60d9 !important;
    .iconfont {
      display: inline-block;
      // transition: all 0.5s;
      // transform: rotate(180deg);
    }
  }
}
.active7 {
  li:nth-child(5) {
    // color: #cd60d9 !important;
    .iconfont {
      display: inline-block;
      // transition: all 0.5s;
      // transform: rotate(180deg);
    }
  }
}
.active8 {
  li:nth-child(4) {
    // color: #cd60d9 !important;
    .iconfont {
      display: inline-block;
      // transition: all 0.5s;
      // transform: rotate(180deg);
    }
  }
}

.Social-Img {
  width: 24px;
  height: 24px;
  margin: 15px 0 0 10px;
  float: left;
  cursor: pointer;
  border-bottom: none !important;
  padding: 0 !important;
}
a {
  .Social-Img2 {
    background: url("../../assets/pc/Home/Home10.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img2:hover {
    background: url("../../assets/pc/Home/Social/路径 10@2x.png") no-repeat
      center;
    background-size: 100% !important;
  }
}
a {
  text-decoration: none !important;
  .Social-Img3 {
    background: url("../../assets/pc/Home/Home13.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img3:hover {
    background: url("../../assets/pc/Home/Social/路径 11@2x.png") no-repeat
      center;
    background-size: 100% !important;
  }
  .Social-Img4 {
    background: url("../../assets/pc/Home/Home12.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img4:hover {
    background: url("../../assets/pc/Home/Social/路径 12@2x.png") no-repeat
      center;
    background-size: 100% !important;
  }
  .Social-Img5 {
    background: url("../../assets/pc/Home/Home9.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img5:hover {
    background: url("../../assets/pc/Home/Social/减去顶层 7@2x.png") no-repeat
      center;
    background-size: 100% !important;
  }
  .Social-Img6 {
    background: url("../../assets/pc/Home/Home8.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img6:hover {
    background: url("../../assets/pc/Home/Social/减去顶层 8@2x.png") no-repeat
      center;
    background-size: 100% !important;
  }
  .Social-Img7 {
    background: url("../../assets/pc/Home/gita.png") no-repeat center;
    background-size: 100% !important;
  }
  .Social-Img7:hover {
    background: url("../../assets/pc/Home/Social/gita.png") no-repeat center;
    background-size: 100% !important;
  }
}
</style>
